import { languageHelper } from "../../../config/helperFunctions";
import React, { useState, useEffect } from 'react'
import Select from "react-select";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { apiKey } from "../../../config/config";
import { toast } from "react-toastify";

function ItemProducts() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const { id } = useParams();
  const navigate = useNavigate();

  const [data, setData] = useState([])
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [categories, setCategories] = useState([])
  const [selectedCategory, setSelectedCategory] = useState(null);

  const handleSelectProduct = (product) => {
    if (selectedProducts.includes(product.id)) {
      setSelectedProducts(selectedProducts.filter((id) => id !== product.id));
    } else {
      setSelectedProducts([...selectedProducts, product.id]);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    axios.post(`${apiKey}/api/rms/admin/foodMenus/copyItems`, {
      products: selectedProducts,
      categoryId: selectedCategory
    }, {
      headers: {
        Authorization: `Bearer ${user?.token}`,
      },
    })
      .then((res) => {
        toast.success(res.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        navigate(-1);
      })
      .catch((err) => {
        toast.error(err.response.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      })
  }

  useEffect(() => {
    axios.get(`${apiKey}/api/rms/admin/foodMenus`, {
      headers: {
        Authorization: `Bearer ${user?.token}`,
      },
      params: {
        categoryId: id
      }
    })
      .then((res) => {
        setData(res.data.foodMenus)
      })
      .catch((err) => {
        console.log(err)
      })
  }, [user?.token, id])

  useEffect(() => {
    axios.get(`${apiKey}/api/rms/admin/categories`, {
      headers: {
        Authorization: `Bearer ${user?.token}`,
      },
    })
      .then((res) => {
        setCategories(res.data.map(item => {
          if (id !== item.id) {
            return {
              value: item.id,
              label: `${item.category_name} - ${item.cat_name_arabic}`
            }
          }
          return null
        }).filter(item => item !== null))
      })
      .catch((err) => {
        console.log(err)
      })
  }, [user?.token, id])

  return (

    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">

        <div>
          <h1 className="text-[#7B20C7] text-2xl font-semibold pt-5 pb-2">{languageHelper("Products")}</h1>
        </div>
        <button
          className="bg-[#7B20C7] text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-3 ease-linear transition-all duration-150 text-center w-fit"
          type="button"
          onClick={() => navigate(-1)}
        >
          {languageHelper("Back To Category")}
        </button>

        <div>
          <label htmlFor="" className='text-xs font-semibold'>{languageHelper("Category")}</label>
          <div className="mb-4 pt-0 w-1/3">
            <Select
              onChange={(e) => setSelectedCategory(e.value)}
              options={categories}
              type="text"
              placeholder={languageHelper("Select")}
              className="placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
              required />
          </div>
        </div>

        <div className="flex flex-wrap gap-6">
          {data.map((item) => (
            <div onClick={() => handleSelectProduct(item)} className={`border-solid border-2 border-[#7B20C7] cursor-pointer rounded-2xl w-36 hover:transition-all hover:bg-[#7B20C7] group cursor-pointer ${selectedProducts.includes(item.id) ? "bg-[#7B20C7] text-white" : ""}`}>
              <h1 className="flex justify-center align-middle py-6 text-md font-semibold group-hover:text-white ">{item.name}-{item.name_arabic}</h1>
            </div>
          ))}
        </div>

        <span className="w-full bg-[#7B20C7] h-1 my-2 mt-8 inline-block"></span>
        <div className="flex gap-2">
          <button
            onClick={handleSubmit}
            className="bg-[#7B20C7] text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
            type="submit">
            {languageHelper("Submit")}
          </button>
        </div>
      </div>
    </main>
  )
}

export default ItemProducts
